/**
 * The Vault's "Recently Used" tab: opened packs, used prompts, loaded presets.
 *
 * `r.title` and `r.name` fall back to '' because the recent-entry records store
 * whichever label the source asset had — a prompt has a title, a preset has a name,
 * and neither field is present on both.
 */
import { ToolButton } from '../studio';
import type { VaultPack } from '../../types/domain';
import { Note, RecentRow, type VaultController } from './shared';

export interface VaultRecentTabProps {
  vault: VaultController;
  onOpenPack: (pack: VaultPack) => void;
}

export default function VaultRecentTab({ vault, onOpenPack }: VaultRecentTabProps) {
  return (
    <div>
      <Note>Recently opened packs</Note>
      {vault.recentPackList.length === 0 ? (
        <Note marginBottom={18}>Nothing opened yet.</Note>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 18 }}>
          {vault.recentPackList.map((p) => (
            <ToolButton key={p.id} onClick={() => onOpenPack(p)}>
              {p.name}
            </ToolButton>
          ))}
        </div>
      )}

      <Note>Recently used prompts</Note>
      {vault.recentPrompts.length === 0 ? (
        <Note marginBottom={18}>No prompts used yet.</Note>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 18 }}>
          {vault.recentPrompts.map((r) => (
            <RecentRow key={r.id} label={r.title ?? ''} date={r.date} />
          ))}
        </div>
      )}

      <Note>Recently loaded presets</Note>
      {vault.recentPresets.length === 0 ? (
        <Note marginBottom={0}>No presets loaded yet.</Note>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {vault.recentPresets.map((r) => (
            <RecentRow key={r.id} label={r.name ?? ''} date={r.date} />
          ))}
        </div>
      )}
    </div>
  );
}
